import Model from "./Model";

export default class Template extends Model {
  static type = "templates";

  name: string;
  description?: string;
  questionTemplatesCount: number;
  databaseId: string;
}
